var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 465.57010377739925 103.18751250270338",
    width: 465.57010377739925,
    height: 103.18751250270338,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    className: "style-fonts"
  }, "\n      @font-face {\n        font-family: \"Virgil\";\n        src: url(\"https://excalidraw.com/Virgil.woff2\");\n      }\n      @font-face {\n        font-family: \"Cascadia\";\n        src: url(\"https://excalidraw.com/Cascadia.woff2\");\n      }\n      @font-face {\n        font-family: \"Assistant\";\n        src: url(\"https://excalidraw.com/Assistant-Regular.woff2\");\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 465.57010377739925,
    height: 103.18751250270338,
    fill: "#030723"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(10 10) rotate(0 201.88606728995842 34.895725163938096)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L403.77 0 L403.77 69.79 L0 69.79",
    stroke: "none",
    strokeWidth: 0,
    fill: "#030723"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C92.46 0, 184.91 0, 403.77 0 M0 0 C136.68 0, 273.35 0, 403.77 0 M403.77 0 C403.77 14.4, 403.77 28.8, 403.77 69.79 M403.77 0 C403.77 16.85, 403.77 33.69, 403.77 69.79 M403.77 69.79 C300.48 69.79, 197.19 69.79, 0 69.79 M403.77 69.79 C264.56 69.79, 125.35 69.79, 0 69.79 M0 69.79 C0 49.19, 0 28.58, 0 0 M0 69.79 C0 55.23, 0 40.67, 0 0",
    stroke: "transparent",
    strokeWidth: 0.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.432896746149254 15.24882147459698) rotate(0 217.068603515625 33.55837434284638)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "53.693398948554275px",
    fill: "#a5d8ff",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "CONSTEMS - AI")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(123.8145030032922 74.33396292616135) rotate(0 115.87459564208984 9.426774788271018)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontFamily: "Virgil, Segoe UI Emoji",
    fontSize: "15.082839661233708px",
    fill: "#a5d8ff",
    textAnchor: "start",
    style: {
      whiteSpace: "pre"
    },
    direction: "ltr",
    dominantBaseline: "text-before-edge"
  }, "AI Analysis Tools and Services")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3c48738d71ed31214a924f23c2c743cc.svg";
export { ForwardRef as ReactComponent };